var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-ppt-radial-gradual-select" },
    [
      _c(
        "div",
        {
          ref: "sliderBox",
          staticClass: "dsf-ppt-radial-gradual-select__pane",
          on: { mousedown: _vm.mousedown },
        },
        [
          _c("div", { style: _vm.paneStyle }),
          _c("span", {
            ref: "thumb",
            staticClass: "slider",
            style: _vm.sliderStyle,
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "dsf-ppt-radial-gradual-select__item" },
        [
          _c("span", [_vm._v("渐变边界")]),
          _c(
            "el-select",
            {
              attrs: { size: "mini" },
              on: { change: _vm.updateValue },
              model: {
                value: _vm.size,
                callback: function ($$v) {
                  _vm.size = $$v
                },
                expression: "size",
              },
            },
            _vm._l(_vm.config.size, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { value: item.value, label: item.text },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "dsf-ppt-radial-gradual-select__size" }),
      _c("color-slider", {
        staticClass: "dsf-ppt-radial-gradual-select__bar",
        on: { change: _vm.updateValue },
        model: {
          value: _vm.point,
          callback: function ($$v) {
            _vm.point = $$v
          },
          expression: "point",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }